import {UIDHeaderController} from '../../ui_html/header/UIDHeaderController'
import {UIWHeaderController} from '../../ui_html/header/UIWHeaderController'
import {UIDStoreController} from '../../store/UIDStoreController.ts'

export class UIDStoreSceneController {
    private readonly headerController: UIWHeaderController
    private readonly storeSceneContainerDiv: HTMLDivElement
    readonly storeController: UIDStoreController

    constructor(headerController: UIWHeaderController) {
        this.headerController = headerController
        this.storeSceneContainerDiv = document.getElementById('scene_discord_store_container') as HTMLDivElement
        this.storeController = new UIDStoreController()
    }

    hide() {
        this.storeSceneContainerDiv.classList.add('hidden')
    }

    show() {
        this.storeSceneContainerDiv.classList.remove('hidden')

        if(this.headerController instanceof UIDHeaderController) this.headerController.activateStoreButton()
    }
}
